import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../services/system/storage.service';
import { BoardTheme } from '../../../models/inModels/BoardTheme';
import { BoardThemeService } from '../../../services/board-themes/board-themes.service';

@Component({
  selector: 'app-create-board-theme',
  templateUrl: './create-board-theme.component.html'
})

export class CreateBoardThemeComponent  {
	model: BoardTheme;
	loading = false;
	error: Message[];
	messages: Message[];
	constructor(
		public storageService: StorageService,
		private router: Router,
		private service: BoardThemeService,) {
		this.model = new BoardTheme();
	}

	ngOnInit() {
	}

	goBack(): void {
		this.router.navigate(['/board-themes']);
	}

	save() {
		this.loading = true;
		this.service.create(this.model).then(
			result => {
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	handleBackgroundImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.backgroundImageId = result.PublicId;
		this.loading = false;
	}
		
	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/board-themes/create-board-theme/create-board-theme.component.ts